import { BadgeVariant } from 'components/common/Badge'
import { capitalize } from 'lodash'
import { Ticket, TicketComment } from 'components/tickets/types'
import moment from 'moment-timezone'

export const ticketStatusBadgeVariants: Record<Ticket['status'], BadgeVariant> = {
  new: 'warning-solid',
  pending: 'primary-solid',
  'on-hold': 'neutral-solid',
  open: 'error-solid',
  solved: 'neutral',
  closed: 'neutral',
}

export const ticketCommentTypeBadgeVariants: Record<TicketComment['type'], BadgeVariant> = {
  internal: 'warning',
  external: 'neutral',
}

export const getTicketStatusLabel = (status: Ticket['status']) => {
  switch (status) {
    case 'on-hold': {
      return 'On-Hold'
    }
    default: {
      return capitalize(status || '')
    }
  }
}

export const getTicketCommentTypeLabel = (type: TicketComment['type']) => {
  switch (type) {
    case 'external': {
      return 'External Communication'
    }
    default: {
      return capitalize(type || '')
    }
  }
}

export const formatTicketDate = (date: string | Date, dateOnly = false) => {
  if (!date) return ''

  const format = dateOnly ? 'MM/DD/YYYY' : 'MM/DD/YYYY  h:mm A z'
  return moment.tz(date, Intl.DateTimeFormat().resolvedOptions().timeZone).format(format)
}
